import React from 'react'

export const UpNextArrow = () => {
    return (
        <svg
            width="8"
            height="11"
            viewBox="0 0 8 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.80781 1.49164L3.80781 9.43164M3.80781 9.43164L1.32656 6.95039M3.80781 9.43164L6.28906 6.95039"
                stroke="#E6011F"
                strokeWidth="1.48875"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
